export const industryNewsRecords = [
  {
    slug: "industry-new-power-system-bluebook-energy-saving-transformers",
    category: "industry",
    title: {
      "zh-CN": "《新型电力系统发展蓝皮书》发布，配网节能变压器迎来政策红利",
      "en-US": "New Power System Development Blue Book Released, Bringing Policy Support for Energy-Efficient Distribution Transformers"
    },
    excerpt: {
      "zh-CN": "国家能源局发布的《新型电力系统发展蓝皮书》明确提出，要加快配电网智能化改造，全面推广一级能效配电变压器。",
      "en-US": "The blue book calls for accelerated intelligent distribution grid upgrades and broader adoption of Grade I energy efficiency distribution transformers."
    },
    date: "2026-01-15",
    views: 168,
    sourceName: { "zh-CN": "行业政策整理", "en-US": "Industry Policy Compilation" },
    sourceUrl: "",
    content: {
      "zh-CN": [
        "国家能源局发布的《新型电力系统发展蓝皮书》明确提出，要加快配电网智能化改造，全面推广一级能效配电变压器。",
        "根据规划，到2030年，我国新型电力系统建设将带动中低压节能变压器市场规模突破2000亿元，低损耗、高可靠性产品将成为市场主流。江苏宏邦紧跟政策导向，持续推进S20、SCB14等系列节能变压器的规模化生产，助力电网节能降碳。"
      ],
      "en-US": [
        "The New Power System Development Blue Book released by the National Energy Administration clearly proposes accelerating intelligent upgrades of distribution networks and promoting Grade I energy efficiency distribution transformers on a broader scale.",
        "According to the plan, by 2030, China's new power system construction is expected to drive the medium- and low-voltage energy-efficient transformer market beyond RMB 200 billion.",
        "Low-loss and high-reliability transformer products are expected to become mainstream in the market.",
        "Jiangsu Hongbang is following the policy direction and continuing to promote scaled production of energy-efficient transformer series such as S20 and SCB14, supporting energy saving and carbon reduction across the power grid."
      ]
    }
  },
  {
    slug: "industry-grid-distribution-equipment-technical-standard-quality-upgrade",
    category: "industry",
    title: {
      "zh-CN": "国家电网发布《配网设备技术标准》，推动变压器行业质量升级",
      "en-US": "State Grid Issues New Technical Standards for Distribution Equipment, Driving Quality Upgrading in Transformer Industry"
    },
    excerpt: {
      "zh-CN": "新版《10kV配电变压器技术标准》对产品能效、噪声和抗短路能力提出更高要求。",
      "en-US": "The revised technical standard introduces higher requirements for energy efficiency, noise performance and short-circuit withstand capability."
    },
    date: "2025-09-20",
    views: 152,
    sourceName: { "zh-CN": "行业标准整理", "en-US": "Industry Standards Compilation" },
    sourceUrl: "",
    content: {
      "zh-CN": [
        "国家电网有限公司发布新版《10kV配电变压器技术标准》，对产品的能效、噪声、抗短路能力提出了更高要求。",
        "新标准明确，新建配电工程优先采用一级能效变压器，并对出厂试验、型式试验提出了更严格的检测要求。行业分析指出，这将加速行业内落后产能的淘汰，推动优势企业向高质量、高技术方向转型。"
      ],
      "en-US": [
        "State Grid Corporation of China has released a revised version of the Technical Standard for 10kV Distribution Transformers, introducing higher requirements for energy efficiency, noise performance, and short-circuit withstand capability.",
        "The new standard specifies that newly constructed distribution projects shall prioritize Grade I energy efficiency transformers, while also imposing stricter requirements on factory acceptance tests and type tests.",
        "Industry analysis indicates that implementation of the new standard will accelerate the elimination of outdated production capacity and promote the transformation of leading enterprises toward higher quality, higher technology, and more reliable product development in the power equipment sector."
      ]
    }
  },
  {
    slug: "industry-power-equipment-growth-plan-2025-2026",
    category: "industry",
    title: {
      "zh-CN": "三部门印发《电力装备行业稳增长工作方案（2025-2026年）》",
      "en-US": "Three Authorities Jointly Issue Action Plan for Stable Growth of Power Equipment Industry (2025-2026)"
    },
    excerpt: {
      "zh-CN": "方案支持新能源、智能电网装备等领域创新项目，推动电力装备行业稳增长和结构升级。",
      "en-US": "The plan supports innovation in new energy and smart grid equipment while promoting standards, digital transformation and market expansion."
    },
    date: "2025-09-12",
    views: 141,
    sourceName: { "zh-CN": "中国政府网", "en-US": "Chinese Government Website" },
    sourceUrl: "https://www.gov.cn/lianbo/bumen/202509/content_7040865.htm",
    content: {
      "zh-CN": [
        "工业和信息化部、市场监管总局、国家能源局联合印发《电力装备行业稳增长工作方案（2025-2026年）》，提出2025至2026年传统电力装备年均营收增速保持6%左右，新能源装备营收稳中有升。",
        "方案强调支持新能源、智能电网装备等领域创新项目，并通过强化标准支撑、推动数字化绿色化转型、扩大国内有效需求和开拓国际市场，夯实电力装备行业增长基础。对于变压器、成套开关设备和箱式变电站企业而言，标准升级和工程需求释放将共同推动产品结构升级。"
      ],
      "en-US": [
        "The Ministry of Industry and Information Technology, the State Administration for Market Regulation, and the National Energy Administration have jointly released the Action Plan for Stable Growth of the Power Equipment Industry (2025-2026).",
        "The plan sets a target for the period 2025-2026, aiming to maintain an average annual revenue growth of approximately 6% for traditional power equipment, while ensuring steady and sustained growth in the new energy equipment sector.",
        "It emphasizes support for innovation-driven projects in areas such as new energy systems and smart grid equipment, while strengthening standards development, promoting digital and green transformation, expanding domestic demand, and accelerating international market development.",
        "For manufacturers of transformers, switchgear, and compact substations, the combined effect of evolving technical standards and accelerating project demand is expected to drive continued product structure upgrading and long-term market expansion."
      ]
    }
  },
  {
    slug: "industry-customs-transformer-export-2024-growth",
    category: "industry",
    title: {
      "zh-CN": "海关总署数据：2024年我国变压器出口额同比增长12.3%，新兴市场表现突出",
      "en-US": "China's Transformer Exports Grow 12.3% YoY in 2024, with Strong Performance in Emerging Markets"
    },
    excerpt: {
      "zh-CN": "东南亚、中东、非洲等地区出口增速均超过20%，耐候性和定制化产品需求显著提升。",
      "en-US": "Exports to Southeast Asia, the Middle East and Africa recorded strong growth, while demand for customized and weather-resistant products increased."
    },
    date: "2025-04-10",
    views: 136,
    sourceName: { "zh-CN": "海关数据整理", "en-US": "Customs Data Compilation" },
    sourceUrl: "",
    content: {
      "zh-CN": [
        "据海关总署统计数据，2024年我国电力变压器出口额达187.6亿元，同比增长12.3%。",
        "其中，东南亚、中东、非洲等地区出口增速均超过20%，成为拉动出口增长的主要动力。市场对耐候性、定制化产品的需求显著提升，为具备快速响应与本地化服务能力的企业带来新机遇。"
      ],
      "en-US": [
        "According to data released by the General Administration of Customs of China, the export value of power transformers reached RMB 18.76 billion in 2024, representing a year-on-year increase of 12.3%.",
        "Exports to emerging markets, including Southeast Asia, the Middle East, and Africa, recorded growth rates exceeding 20%, making these regions the primary drivers of export expansion.",
        "Market demand for climate-resistant, application-specific, and customized transformer solutions continues to rise significantly.",
        "This trend is creating new opportunities for manufacturers with strong capabilities in rapid response, engineering customization, and localized service support."
      ]
    }
  },
  {
    slug: "industry-transformer-efficiency-standard-gb-20052-2020",
    category: "industry",
    title: {
      "zh-CN": "《变压器能效限定值及能效等级》（GB 20052-2020）全面实施，能效门槛大幅提高",
      "en-US": "GB 20052-2020 Energy Efficiency Standards Fully Implemented, Raising Entry Threshold for Power Transformers"
    },
    excerpt: {
      "zh-CN": "新标准将配电变压器能效分为三级，新采购配电变压器需达到更高能效要求。",
      "en-US": "The mandatory national standard raises transformer efficiency requirements and accelerates the phase-out of high-loss products."
    },
    date: "2024-11-05",
    views: 128,
    sourceName: { "zh-CN": "国家标准整理", "en-US": "National Standard Compilation" },
    sourceUrl: "",
    content: {
      "zh-CN": [
        "国家强制性标准《电力变压器能效限定值及能效等级》（GB 20052-2020）已全面实施，新标准将配电变压器能效分为三级，其中一级能效指标较旧标准提升约10%。",
        "自2025年起，新采购配电变压器必须达到二级及以上能效要求，高损耗产品将逐步退出市场。江苏宏邦全系列产品均已按新标准进行能效升级，多款产品达到一级能效水平。"
      ],
      "en-US": [
        "The mandatory national standard Energy Efficiency Limits and Energy Efficiency Grades for Power Transformers (GB 20052-2020) has been fully implemented, significantly raising the energy performance requirements for the industry.",
        "Under the new standard, distribution transformers are classified into three efficiency grades, with Grade I efficiency improving by approximately 10% compared with the previous standard.",
        "Starting from 2025, all newly procured distribution transformers are required to meet Grade II efficiency or above, while high-loss products will be gradually phased out from the market.",
        "In line with the new regulatory requirements, Jiangsu Hongbang Transformer Co., Ltd. has upgraded the energy efficiency performance across its full product range. Multiple models have already achieved Grade I energy efficiency, supporting the industry's transition toward high-efficiency and low-loss power equipment."
      ]
    }
  },
  {
    slug: "industry-power-equipment-high-quality-development-action-plan",
    category: "industry",
    title: {
      "zh-CN": "工信部发布《电力装备高质量发展行动计划》，推动行业向智能化、绿色化转型",
      "en-US": "MIIT Releases Action Plan for High-Quality Development of Power Equipment Industry, Accelerating the Shift Toward Smart and Green Transformation"
    },
    excerpt: {
      "zh-CN": "行动计划提出重点发展节能高效变压器、智能配电设备等产品，支持企业开展智能制造改造。",
      "en-US": "The action plan prioritizes energy-efficient transformers, smart distribution equipment and digitalized manufacturing upgrades."
    },
    date: "2024-06-18",
    views: 119,
    sourceName: { "zh-CN": "工信部政策整理", "en-US": "MIIT Policy Compilation" },
    sourceUrl: "",
    content: {
      "zh-CN": [
        "工业和信息化部发布《电力装备高质量发展行动计划（2024-2026年）》，提出重点发展节能高效变压器、智能配电设备等产品，支持企业开展智能制造改造，提升产品数字化管控能力。",
        "计划明确，到2026年，骨干企业数字化车间普及率达到60%以上，这为变压器行业的技术升级指明了方向。对于配电设备制造企业而言，数字化制造、检测能力和绿色产品体系将成为长期竞争重点。"
      ],
      "en-US": [
        "The Ministry of Industry and Information Technology has issued the Action Plan for High-Quality Development of the Power Equipment Industry (2024-2026), outlining priorities to advance energy-efficient transformers, high-performance distribution equipment, and smart grid products.",
        "The plan encourages enterprises to accelerate smart manufacturing transformation and upgrading, and to enhance digitalized production management and product lifecycle control capabilities.",
        "It further sets a clear target that by 2026, the penetration rate of digital workshops among leading enterprises will exceed 60%, providing a clear roadmap for technological upgrading across the transformer and power distribution equipment industry.",
        "For manufacturers of distribution equipment, digital manufacturing capability, advanced testing systems, and green product portfolios will become long-term competitive priorities."
      ]
    }
  },
  {
    slug: "industry-offshore-wind-transformer-launch-special-equipment-demand",
    category: "industry",
    title: {
      "zh-CN": "66kV海上风电变压器持续突破，新能源专用变压器需求加速释放",
      "en-US": "66kV Offshore Wind Power Transformers Achieve Continued Breakthroughs as Demand for Renewable Energy-Specific Transformers Accelerates"
    },
    excerpt: {
      "zh-CN": "海上风电项目持续推进，专用变压器产品成为新能源装备中的重要增长方向。",
      "en-US": "Offshore wind applications are increasing demand for high-reliability, weather-resistant and application-specific transformer products."
    },
    date: "2024-03-26",
    views: 112,
    sourceName: { "zh-CN": "国际风力发电网", "en-US": "International Wind Power Network" },
    sourceUrl: "https://wind.in-en.com/html/wind-2455704.shtml",
    content: {
      "zh-CN": [
        "公开报道显示，国内企业持续推进大容量油浸式海上风电变压器研发和应用，海上风电场景对高可靠性、耐候性和专用化设计提出了更高要求。",
        "随着海上风电项目持续推进，面向高盐雾、高湿度、高可靠性要求场景的专用变压器产品将成为新能源装备中的重要增长方向。对于变压器企业而言，新能源配套设备的迭代速度和专业场景扩张也意味着更广阔的产品应用空间。"
      ],
      "en-US": [
        "Public reports indicate that domestic manufacturers are continuously advancing the development and application of large-capacity oil-immersed offshore wind power transformers.",
        "Offshore wind applications impose significantly higher requirements in terms of high reliability, weather resistance, and application-specific engineering design.",
        "As offshore wind power projects continue to expand, specialized transformers designed for high salinity, high humidity, and high-reliability operating environments are emerging as a key growth segment within the renewable energy equipment industry.",
        "For transformer manufacturers, the accelerating iteration of renewable energy supporting equipment and the expansion of specialized application scenarios are creating broader opportunities for product deployment in the new energy sector."
      ]
    }
  },
  {
    slug: "industry-energy-efficiency-improvement-key-products-transformer-retrofit",
    category: "industry",
    title: {
      "zh-CN": "国家发改委发布《重点用能产品能效提升行动方案》，变压器节能改造纳入重点工程",
      "en-US": "NDRC Releases Energy Efficiency Improvement Plan for Key Energy-Consuming Products, Transformer Efficiency Upgrades Included in Key Programs"
    },
    excerpt: {
      "zh-CN": "方案明确将配电变压器列为重点节能改造对象，推动存量高损耗设备加快更新。",
      "en-US": "The plan identifies distribution transformers as a priority for energy-saving upgrades and accelerates replacement of high-loss equipment."
    },
    date: "2023-11-22",
    views: 108,
    sourceName: { "zh-CN": "政策方案整理", "en-US": "Policy Plan Compilation" },
    sourceUrl: "",
    content: {
      "zh-CN": [
        "国家发改委发布《重点用能产品能效提升行动方案》，明确将配电变压器列为重点节能改造对象，提出到2025年，完成存量高损耗配电变压器改造200万台以上，全面淘汰S11及以下能效等级产品。",
        "方案要求新建工业与配电项目优先选用一级能效变压器，预计带动节能变压器市场规模超500亿元，为行业绿色转型提供了明确政策指引。"
      ],
      "en-US": [
        "The National Development and Reform Commission has issued the Action Plan for Energy Efficiency Improvement of Key Energy-Consuming Products, explicitly identifying distribution transformers as a priority category for energy-saving upgrades.",
        "The plan sets a clear target that by 2025, more than 2 million high-loss existing distribution transformers will be upgraded, and transformer products with efficiency levels of S11 and below will be fully phased out.",
        "The policy further requires newly constructed industrial and distribution network projects to prioritize Grade I energy efficiency transformers, driving accelerated replacement of inefficient equipment across the power system.",
        "This initiative is expected to stimulate a market scale of over RMB 50 billion for energy-efficient transformers, providing a clear policy framework for the industry's transition toward high-efficiency, low-loss and sustainable power infrastructure."
      ]
    }
  },
  {
    slug: "industry-grid-investment-distribution-network-2023",
    category: "industry",
    title: {
      "zh-CN": "两大电网扩大配网投资，2023年配网建设规模超5000亿元",
      "en-US": "Power Grid Investment Continues to Expand as Distribution Network Construction Accelerates"
    },
    excerpt: {
      "zh-CN": "农村电网升级、工业园区配电改造与新能源并网工程推动配网变压器和箱式变电站需求增长。",
      "en-US": "Grid modernization and renewable energy integration are driving steady demand for distribution transformers, compact substations and medium-voltage equipment."
    },
    date: "2023-05-16",
    views: 102,
    sourceName: { "zh-CN": "电网投资信息整理", "en-US": "Grid Investment Information Compilation" },
    sourceUrl: "",
    content: {
      "zh-CN": [
        "据国家电网、南方电网公开信息，2023年两大电网企业配网建设投资规模合计突破5000亿元，重点投向农村电网升级、工业园区配电改造与新能源并网配套工程。",
        "配网变压器、箱式变电站等设备需求持续增长，其中10kV-35kV节能型变压器采购占比同比提升18%，为变压器制造企业带来稳定市场增量。"
      ],
      "en-US": [
        "According to publicly disclosed information from State Grid Corporation of China and China Southern Power Grid, the combined investment in distribution network construction by the two major utilities exceeded RMB 500 billion in 2023.",
        "Investment is mainly directed toward rural power grid reinforcement, industrial park distribution network upgrading, and supporting works for new energy grid connection projects.",
        "Driven by ongoing grid modernization and the rapid integration of renewable energy sources, demand for distribution transformers, compact substations, and related medium-voltage equipment continues to grow steadily.",
        "In particular, procurement of energy-efficient distribution transformers in the 10kV-35kV voltage class recorded a year-on-year increase of approximately 18%, reflecting the continuous shift toward low-loss and high-efficiency power infrastructure.",
        "This sustained investment trend is expected to generate stable incremental demand for transformer manufacturers, especially in distribution network equipment, energy-efficient transformer solutions, and grid modernization applications."
      ]
    }
  },
  {
    slug: "industry-global-transformer-shortage-ai-grid-upgrade",
    category: "industry",
    title: {
      "zh-CN": "AI算力与电网升级推高全球变压器需求，高可靠供电设备进入紧平衡周期",
      "en-US": "AI Computing and Power Grid Upgrades Drive Global Transformer Demand, High-Reliability Power Supply Enters a Tight Balance Cycle"
    },
    excerpt: {
      "zh-CN": "全球电网升级、能源转型与AI数据中心扩张叠加，正在推动大型电力变压器进入供需紧张周期。",
      "en-US": "Energy transition, grid renewal and AI data center expansion are increasing demand for high-reliability transformer equipment worldwide."
    },
    date: "2026-03-18",
    views: 96,
    sourceName: { "zh-CN": "国际能源网", "en-US": "International Energy Network" },
    sourceUrl: "https://www.in-en.com/article/html/energy-2342209.shtml",
    content: {
      "zh-CN": [
        "公开行业资讯显示，全球变压器市场正在经历结构性供需变化，北美、欧洲和新兴市场对高等级变压器的需求快速上升，交货周期和价格都出现明显拉长与抬升。",
        "能源转型、电网老化改造和AI数据中心扩容，共同推高了对高可靠供电设备的需求，也让变压器制造企业的交付能力、标准能力和海外适配能力成为竞争核心。"
      ],
      "en-US": [
        "Industry information indicates that the global transformer market is undergoing a structural shift in supply and demand.",
        "Demand for higher-grade transformers is rising rapidly across North America, Europe, and emerging markets, while lead times and pricing levels have shown a clear upward trend.",
        "The combined impact of energy transition, aging grid infrastructure upgrades, and the rapid expansion of AI data centers is significantly increasing demand for high-reliability power supply equipment.",
        "As a result, manufacturers are facing stricter requirements in terms of delivery capability, compliance with international standards, and overseas application adaptability, which have become key competitive factors in the global transformer industry."
      ]
    }
  }
];
